/* eslint-disable import/prefer-default-export */

import React from 'react';

import Admin from 'hive-admin';

import { renderCurrency } from './SystemCountry';
import Types from '../modules/types';

import FieldTable, { InputCheckbox } from './FieldTable';

const {
  PAYMENT_METHOD,
  PAYMENT_METHOD_LABELS_MAP,
} = Types;

export const PAYMENT_METHODS = PAYMENT_METHOD.filter(method => (
  method !== 'FREE' && method !== 'TAMARA' && method !== 'TABBY'
));

Admin.addToLibrary(
  'FieldPaymentMethods',
  config => FieldTable.create({
    label: 'Payment methods',
    table: { showHeader: false, rowKey: 'method', size: 'small' },
    // eslint-disable-next-line max-len
    help: (
      <>
        Limit payment options acceptable when shipping with
        {
            config.helpShippingLabel
          ? ` ${config.helpShippingLabel} shipping.`
          : ' this shipping provider.'
        }
        <br />
        <br />
        The final choices presented to the customer may vary based on
        many factors (eg. customers country, amount being charged, etc.).
      </>
    ),
    paymentMethods: PAYMENT_METHODS,
    prepareValueForInput: (value = {}, props) => props.paymentMethods.reduce(
      (agr, method) => {
        if (value && value[method]) {
          agr.push({ supported: true, ...value[method], method, _id: method });
        } else {
          agr.push({ method, _id: method, supported: false, price: 0 });
        }
        return agr;
      },
      [],
    ),
    prepareValueForForm: (value, props) => value.reduce(
      (agr, row, index) => {
        agr[props.paymentMethods[index]] = row;
        return agr;
      },
      {},
    ),
    columns: [
      {
        key: 'supported',
        align: 'center',
        width: '50px',
        fields: [{
          name: 'supported',
          ComponentInput: InputCheckbox,
          props: {
            size: 'small',
          },
        }],
      },
      {
        key: 'label',
        getLabel: ({ method }) => (
          config.paymentMethodLabelsMap?.[method]
          || PAYMENT_METHOD_LABELS_MAP[method]
        ),
      },
      ...(
        config.skipPrice
        ? []
        : [{
            key: 'price',
            width: '160px',
            fields: [{
              name: 'price',
              props: {
                size: 'small',
                align: 'right',
                placeholder: 'Cost',
              },
              // eslint-disable-next-line max-len
              getProps: ({ props }, { supported, price, method } = {}) => ({
                ...props,
                addonBefore: renderCurrency(),
                disabled: !supported || [
                  'CARD', 'TAMARA', 'TABBY',
                ].includes(method),
                value: supported ? price : 'disabled',
              }),
            }],
          }]
      ),
    ],
    ...config,
  }),
);
